import { render } from "./product-information.vue?vue&type=template&id=580ab9bc"
import script from "./product-information.vue?vue&type=script&lang=js"
export * from "./product-information.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__